import React from 'react';
import { createSelector } from '@reduxjs/toolkit';
import { getDictionaryGroups, getGroupsByWorkspaceIdSelector } from './index';
import { isNotNullOrUndefined } from '../../../util/types/Array';
import { RootState } from '../../store.model';
import { Base64 } from '../../../util/Base64';

export const getAllGroupsWithChainGroups = createSelector(
  [getDictionaryGroups],
  (dictionaryGroups) =>
    Object.values(dictionaryGroups ?? {}).map((group) => {
      return {
        ...group,
        chainGroups: group?.pathGroupsIds
          .map((groupId) => dictionaryGroups?.[groupId])
          .filter(isNotNullOrUndefined),
      };
    })
);

export const getAllGroupsInWorkspaceWithChainGroups = createSelector(
  [
    (state: RootState, props: { workspaceId: string }) =>
      getGroupsByWorkspaceIdSelector(state, props),
    getAllGroupsWithChainGroups,
  ],
  (dictionaryGroups, groups) =>
    Object.values(dictionaryGroups?.data?.entities.groups ?? {}).map(
      (group) => {
        return {
          ...group,
          chainGroups: group?.pathGroupsIds
            .map(
              (groupId) =>
                dictionaryGroups?.data?.entities.groups?.[groupId] ??
                groups.find(
                  (group) => Base64.decode(group.id ?? '') === groupId
                )
            )
            .filter(isNotNullOrUndefined),
        };
      }
    )
);
